import { computed, defineComponent, onMounted, ref } from "vue";
import IdentityDialog from "@/components/Identity.vue";
import Header from "@/components/layout/Header.vue";
import store from "@/store";
import GuideDialog from "@/components/guideDialog/Index.vue";
export default defineComponent({
  name: "LayoutContainer",
  components: {
    IdentityDialog,
    Header,
    GuideDialog
  },
  props: {
    msg: String
  },
  setup() {
    // 弹框显示
    const identityDialogVisible = computed(() => store.state.identityDialogVisible);
    // 服务列表
    const serviceList = computed(() => {
      return store.getters["getUserServicesOptions"];
    });
    // 选中数据
    const service = computed(() => {
      return store.state.userInfo.appkey;
    });
    const hasIdentity = computed(() => {
      const identity = store.state.userInfo.identityType;
      return typeof identity === "string";
    });
    onMounted(() => {
      store.dispatch("getUserInfo");
      store.dispatch("getServiceList");
    });
    const CustomCardData = ref({
      name: "标准电子面单模板标准电子面单模板标准电子面单模板",
      code: "JD_template",
      parentTemplateId: 1,
      des: "邮政EMS标准-啦啦啦啦",
      orgId: 0,
      width: 706,
      height: 130,
      areaId: 0,
      thumbnailPath: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      updateTime: "2023-04-30",
      sourceId: 0,
      verId: 0,
      deliveryCode: "string",
      contentPath: "出库单",
      rateValue: 0
    });
    const FragmentCardData = ref({
      name: "标准电子面单模板打印项",
      desc: "",
      fragmentId: 1,
      code: "",
      contentPath: "",
      createTime: "2023-04-30",
      thumbnailPath: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      status: 1,
      rateValue: 0
    });
    const rateValue = ref(0);
    const onClose = data => {
      store.commit("setUserIdentity", data.identityType);
      store.commit("setUserAppKey", data.appkey);
      store.commit("setUserServiceName", data.serviceName);
      store.commit("setIdentityDialogVisible", false);
    };
    // 设置用户服务
    const onServiceChange = (appkey, serviceName) => {
      store.commit("setUserAppKey", appkey);
      store.commit("setUserServiceName", serviceName);
    };
    return {
      CustomCardData,
      FragmentCardData,
      onClose,
      rateValue,
      identityDialogVisible,
      serviceList,
      service,
      onServiceChange,
      hasIdentity
    };
  }
});